import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./../../../ui/ot"
import { useTranslation } from 'react-i18next'

const Cataloging = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'library.cataloging' });

    const navigate = useNavigate()

    const handleClickBox = (value) => {
        navigate('/library/backstage' + value)
    }

    return (
        <MainContainer>
            <Title>{t('cataloging')}</Title>
            <ButtonGroup>
                {false && <>
                    <span>{t('add_record')}</span>
                    <Button variant="outline">{t('default_format')}</Button>
                    <DropdownMenu>
                        <DropdownMenuTrigger><Button variant="outline" onClick={e => handleClickBox('/AddMARC')} >{t('defined_format')}</Button></DropdownMenuTrigger>
                        <DropdownMenuContent>
                            <DropdownMenuItem>framework 1</DropdownMenuItem>
                            <DropdownMenuItem>framework 1</DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem>新增格式</DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </>}
            </ButtonGroup>
            <ClickBox onClick={e => handleClickBox('/AddMARC')} >
                {t('add_record')}
            </ClickBox>
            <ClickBox onClick={e => handleClickBox('/StageMARCRecord')} >
                {t('import_bib')}
            </ClickBox>
            <ClickBox onClick={e => handleClickBox('/ManageMARCRecord')} >
                {t('manage_bib')}
            </ClickBox>
            <ClickBox onClick={e => handleClickBox('/LabelPrint')} >
                {t('label_bib')}
            </ClickBox>
            {/* <ClickBox onClick={e => handleClickBox('/BarcodePrint')} >
                {t('print_label_bib')}
            </ClickBox> */}
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
padding: 2em;
gap: 0.5em;
`

const ClickBox = styled.div`
padding: 0.2em;
background-color: rgb(221, 241, 249);
border-radius: 0.5em;
width: 10em;
font-size: 1.2em;
cursor: pointer;
`

const ButtonGroup = styled.div`
display: flex;
gap: 1em;
align-items: center;
}
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

export default Cataloging